 /**collection product Variants***/
document.addEventListener('click', function(e) {
  if (e.target.closest('.select_option')) {
    let thisElement = e.target.closest('.select_option');
    let parentElement = thisElement.closest("[data-product-grid]");
    if (parentElement) {
      let target = parentElement.querySelector('ul.list-unstyled.icon-options a');
      if (target) target.click();
    }
  }
});

// document.querySelectorAll(".custom_product_variants input[type='radio']").forEach(function(radio) {
//     radio.addEventListener('change', function() {
//         let thisElement = this;
//         let variantName = '';
//         let  parentElement = thisElement.closest("[data-product-grid]");
//         let inputs = parentElement.querySelectorAll("input");
//         inputs.forEach(function(input) {
//             if (input.checked) {
//                 variantName += input.getAttribute('option-value');
//             }
//         });
//       let variantSpan = parentElement.querySelector(".select_variant_option option[var-title='" + variantName + "']");         
//       let varId = variantSpan.getAttribute("var-id"); 
//       let varAvailability = variantSpan.getAttribute("avaibility"); 
//       parentElement.setAttribute("variant-id", varId);
//       if(varAvailability == 'sold-out'){
//       parentElement.querySelector('form .Sd_addProduct').setAttribute('disabled','')
//       }else{
//       parentElement.querySelector('form .Sd_addProduct').removeAttribute('disabled','')
//       }
//       parentElement.querySelector('.yv-product-price .money').innerHTML = variantSpan.getAttribute('variant-price'); 
//       if(parentElement.querySelector('.yv-product-compare-price .money') && variantSpan.getAttribute("variant-compare-at-price") != ''){
//         parentElement.querySelector('.yv-product-compare-price .money').innerHTML = variantSpan.getAttribute("variant-compare-at-price");
//       }      
//       parentElement.querySelector('form .Sd_addProduct span').innerHTML = variantSpan.getAttribute("cart-text");
      
//       if(thisElement.closest('.custom_product_variants').querySelector('.yv-variant-title .option-value')){
//       let colorVal =  thisElement.value;
//       thisElement.closest('.custom_product_variants').querySelector('.yv-variant-title .option-value').innerHTML = colorVal;
//       }
//        parentElement.querySelector('.yv-product-img .image-wrapper img').setAttribute('src',variantSpan.getAttribute('variant-image'))  
//     });
// });
/**redmore/less**/
document.querySelectorAll('.readmore').forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelectorAll('.collection-description-full').forEach(el => el.style.display = 'block');
    document.querySelectorAll('.collection-description-short').forEach(el => el.style.display = 'none');
  });
});
 
document.querySelectorAll('.readless').forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelectorAll('.collection-description-full').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.collection-description-short').forEach(el => el.style.display = 'block');
  });
});